import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {OpeningCourses} from 'views/AppLocals/Course/components/OpeningCourses'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from '../OrganizationContainerContext'
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {course_getCourses_Api} from "../../../../apis/course";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FaChalkboardTeacher} from "react-icons/fa";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {SiderBlockHeader} from "../components/SiderBlockHeader";
import {SiderBlockCard} from "../components/SiderBlockCard";

const OrganizationOpeningCourses = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization: item} = useContext(OrganizationContainerContext)
    const owner_id = getId(item)
    const owner_type = getType(item)
    const history = useHistory()

    return (
        <OpeningCourses
            id={[course_getCourses_Api.path, owner_type, owner_id].join("/")}
            values={{status: 1, valid: 1}}
            query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <SiderBlockCard>
                        <SiderBlockHeader
                            icon={FaChalkboardTeacher}
                            iconBgClassName="bg-green-50"
                            iconColorClassName="text-green-500"
                            title={t('courses')}
                        />
                        {children}
                    </SiderBlockCard>
                )
            }}
            // Trước đây hiện "Xem thêm" VÔ ĐIỀU KIỆN (bỏ qua hẳn nextUrl/asyncData truyền vào) - hiện
            // cả khi tổ chức chỉ có đúng 1-2 khoá học, không còn gì để xem thêm. Chỉ hiện khi còn
            // trang kế (nextUrl) HOẶC trang đầu đã fetch nhiều hơn "sample" (2, xem OpeningCourses.js).
            renderLoadMore={(onClick, reachEnd, asyncData, nextUrl) => {
                const fetchedCount = asyncData?.response?.data?.data?.length ?? 0
                if (!nextUrl && fetchedCount <= 2) return null
                return (
                    <span
                        className="flex items-center justify-end gap-1 text-color-300 hover:text-color-100 cursor-pointer"
                        onClick={() => {
                            scrollToRow('contentOrg');
                            history.push(getLinkToDetail(item) + '/courses')
                        }}>
                        <span className="text-xs tracking-wider">
                            {t('see more')}
                        </span>
                        <FiChevronsRight size={13} className="my-auto"/>
                    </span>
                )
            }}
        />
    )
}

export default OrganizationOpeningCourses
